import { render } from "./SearcBlock.vue?vue&type=template&id=58a3ea80&scoped=true&ts=true"
import script from "./SearcBlock.vue?vue&type=script&lang=ts"
export * from "./SearcBlock.vue?vue&type=script&lang=ts"

import "./SearcBlock.vue?vue&type=style&index=0&id=58a3ea80&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a3ea80"]])

export default __exports__